import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TenantDto } from 'projects/shared/src/lib/models/TenantDto';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';

@Component({
  selector: 'tenant-info-mode',
  templateUrl: './edit-tenant-info.component.html',
  styleUrls: ['./edit-tenant-info.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EditTenantInfoComponent implements OnInit {

  @Input('tenant') tenant!:TenantDto;
  
  editTenantForm!:FormGroup;
  systemType!:string;
  isForSystemTest: boolean = false;

  preview: string | ArrayBuffer | null = null;
  // byteArray: Uint8Array | null = null;
  byteArray: any[] | null = null;

  constructor(private fb: FormBuilder, 
    private route: ActivatedRoute,
    private router: Router,
    private tenantService: TenantService,
    public translate: TranslateService,
    private notificationService: NotificationService) { }

  ngOnInit(): void {
    console.log("----------------> tenant-info-mode tenant: ", this.tenant)

    this.preview = this.tenant.image ? 'data:image/png;base64,' + this.tenant.image : null;
    this.tenantService.currentTenantName = this.tenant.name;
    this.tenantService.currentTenantId = this.tenant.id;
    this.systemType = this.tenant.systemType;
    this.isForSystemTest = this.tenant.isForSystemTest;
    this.buildTenantForm(this.tenant);
  }

  buildTenantForm(tenant: TenantDto) {
    this.editTenantForm = this.fb.group({
      id:[tenant.id],
      name:[tenant.displayName],
      scopeName: [tenant.scopeName],
      frontendUrl: [tenant.frontendUrl],
      systemType: [tenant.systemType],
      wpApiKeyInbound: [tenant.wpApiKeyInbound],
      wpServerUrl: [tenant.wpServerUrl],
      wpApiUser: [tenant.wpApiUser],
      wpApiKey: [tenant.wpApiKey],
      wpTenant: [tenant.wpTenant],
      maxUserCount: [tenant.maxUserCount],
      //is_For_systemtest: [tenant.isForSystemTest],
      serverName:""
    })
  }

  editTenant(){
    if(this.editTenantForm.valid){
      let tenant = new TenantDto;
      tenant = this.tenant;
      tenant.maxUserCount = this.editTenantForm.value.maxUserCount;
      tenant.image = this.byteArray ? this.byteArray : tenant.image;
      // console.log("---------> edit-tenant-info - tenant to update: ", tenant);
      // this.notificationService.warning(``,`nicht implmentiert! (edit-tenant-info)`)
      this.tenantService.updateTenancy(tenant).subscribe({
        next:() => {
          this.notificationService.success(``, 'Mandant erfolgreich aktualisiert');
          //this.router.navigate(['/', this.tenantService.currentTenantName, 'manage-tenants']);
        },
        error:(error:any) => {
          this.notificationService.error(``, 'update-tenant-failed' + ': ' + error.message);
        }
      });
    }
  }

  cancel() {
    this.router.navigate(['/', this.tenantService.currentTenantName, 'manage-tenants']);
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const file = input.files[0];
    const reader = new FileReader();

    // Bildvorschau laden
    reader.onload = () => {
      this.preview = reader.result;
    };
    reader.readAsDataURL(file);

    // Byte Array erzeugen
    const readerBinary = new FileReader();
    readerBinary.onload = () => {
      const arrayBuffer = readerBinary.result as ArrayBuffer;
      //this.byteArray = new Uint8Array(arrayBuffer);
      this.byteArray = Array.from(new Uint8Array(arrayBuffer));

      console.log("Byte-Array: ", this.byteArray);
      // Hier kannst du das Byte-Array an den Server schicken
      this.uploadToServer(this.byteArray);
    };
    readerBinary.readAsArrayBuffer(file);
  }

  removeImage() {
    this.preview = null;
    this.byteArray = [];
  }
  
  // Beispiel Server Upload
  uploadToServer(byteArray: any[]) {
    console.log("Uploading to server...", byteArray);
    // HttpClient Code einfügen
  }
}
